import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    padding: 16px 32px 32px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    gap: 24px;

    @media screen and (max-width: ${theme.breakpoints.sm}) {
      padding: 16px 16px 32px;
    }

    > div {
      &:first-of-type {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
      }
    }
  `}
`;
